module.exports = __webpack_public_path__ + "static/img/logo.0e926aff.png";